var map = {
	"./2687-SVL-with-molecule.jpg": 2520,
	"./Alois-fuerstner_web_0.jpg": 5891,
	"./Alois.jpg": 8872,
	"./BFeringa.jpg": 6827,
	"./BOSS XVIII Square Logo.png": 8353,
	"./BOSSXIX-logo2026.jpg": 9241,
	"./BOSSXVIII-Banners-1125x100px-HD2-green.jpg": 3763,
	"./BOSSXVIII-Banners-1125x100px-HD2-green.png": 2487,
	"./BOSS_2022_Symposium_Crowd_Shot.png": 164,
	"./Barry-Trost_web.jpg": 5634,
	"./Dale-Borger_web.jpg": 562,
	"./David-MacMillan.jpg": 4866,
	"./DennisPCurran.jpg": 3658,
	"./ENJ-Photo-1_web.jpg": 8973,
	"./Eric-Jacobsen_web.jpg": 8389,
	"./Francois Diederich Portrait Jannsen Prize.jpg": 809,
	"./Group 216.png": 1888,
	"./Group 5.png": 9452,
	"./HeaderImage.png": 6234,
	"./Header_graphics.png": 3522,
	"./HighlightsBOSSXVIIISymposium.png": 3671,
	"./Hilmar_Weinmann.jpg": 9152,
	"./Ilan_Marek.jpg": 7027,
	"./Janine Cossy.jpg": 57,
	"./JohnHartwig.jpg": 1547,
	"./LDO-Mailing-BOSS-2026-1.jpg": 8480,
	"./Mask Group 10.png": 6197,
	"./Media/Picture1.png": 7801,
	"./Media/Picture10.png": 1702,
	"./Media/Picture10_2025.jpg": 5145,
	"./Media/Picture11.jpg": 8196,
	"./Media/Picture11_2025.jpg": 3369,
	"./Media/Picture12.jpg": 2615,
	"./Media/Picture12_2025.jpg": 7139,
	"./Media/Picture13.jpg": 3510,
	"./Media/Picture13_2025.jpg": 1636,
	"./Media/Picture14.png": 9500,
	"./Media/Picture14_2025.jpg": 9131,
	"./Media/Picture15.jpg": 4714,
	"./Media/Picture15_2025.jpg": 3951,
	"./Media/Picture16.png": 4542,
	"./Media/Picture16_2025.jpg": 3333,
	"./Media/Picture17_2025.jpg": 8883,
	"./Media/Picture1_2025.jpg": 1595,
	"./Media/Picture2.jpg": 9192,
	"./Media/Picture2_2025.jpg": 2950,
	"./Media/Picture3.jpg": 7980,
	"./Media/Picture3_2025.jpg": 9979,
	"./Media/Picture4_2025.jpg": 720,
	"./Media/Picture5.jpg": 1441,
	"./Media/Picture5_2025.jpg": 5520,
	"./Media/Picture6.jpg": 161,
	"./Media/Picture6_2025.jpg": 2495,
	"./Media/Picture7.jpg": 7922,
	"./Media/Picture7_2025.jpg": 5685,
	"./Media/Picture8.png": 7580,
	"./Media/Picture8_2025.jpg": 9352,
	"./Media/Picture9.jpg": 5578,
	"./Media/Picture9_2025.jpg": 2650,
	"./Media/video_1.png": 8050,
	"./Media/video_2.png": 2560,
	"./Nicolaou_Studio_2014-A.jpg": 7517,
	"./Paul-Knochel_2012_web.jpg": 6051,
	"./Piet_Hardewijn.png": 9770,
	"./Toste_MG_4894.jpg": 5435,
	"./VGourverveur.jpg": 5420,
	"./Video_thumbnail.png": 6252,
	"./baldwin.jpg": 7126,
	"./clercq.jpg": 6344,
	"./frank_glorius.jpg": 4441,
	"./frank_glorius.png": 2209,
	"./ghosez.jpg": 7939,
	"./guangbin_dong.jpg": 9420,
	"./hartwig-300x400.jpg": 9417,
	"./image001.jpg": 899,
	"./j-zhu.jpg": 5637,
	"./krief.jpg": 9137,
	"./melanie_sanford.jpg": 1297,
	"./phil_baran.jpg": 5125,
	"./sharpless.jpg": 7924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9536;